import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { baseUrl } from "../../shared/baseUrl";
import { createNotification } from "../Common/CreateNotification";
import { TOKEN_KEY } from "../../Utils/Constants";
import ShimmerCard from "../Common/Shimmer/ShimmerCard";
import ItemCard from "../Common/Item/ItemCard";
import LoadMore from "../Common/LoadMore";
import NoItems from "../Common/NoItems";
import { RenderCollapsible } from "./Categories";


const SingleCategory = () => {
    const { subcategoryId } = useParams();

    const [pageOffset, setScrollPosition] = useState(0);
    const [categories, setCategories] = useState([]);
    const [activeCategory, setActiveCategory] = useState({});
    const [isCatLoading, setIsCatLoading] = useState(false);
    const [isCatItemLoading, setIsCatItemLoading] = useState(false);
    const [products, setProducts] = useState([]);
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [forPagination, setForPagiation] = useState({});
    const [currentPage, setCurrentPage] = useState(1);

    const sideNavRef = useRef();
    const closeBtnRef = useRef();
    const openNavRef = useRef();
    const overlayRef = useRef();

    const handleScroll = () => {
        const position = window.pageYOffset;
        setScrollPosition(position);
    };

    const getByCategory = async (page = 1, catId = subcategoryId) => {
        setIsCatItemLoading(true);
        await fetch(
            baseUrl +
            `product-search?page=${page}${catId !== -1 ? `&category=${catId}` : ""
            }`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    Authorization:
                        localStorage.getItem(TOKEN_KEY) !== null
                            ? "Bearer " + JSON.parse(localStorage.getItem(TOKEN_KEY)).token
                            : null,
                },
            }
        )
            .then((res) => res.json())
            .then((res) => {
                setIsCatItemLoading(false);
                if (res.success) {
                    if (isFirstLoad) {
                        setProducts(res.data.data);
                    } else {
                        setProducts((prevState) => [...prevState, ...res.data.data]);
                    }
                    setForPagiation(res.data);
                    setIsFirstLoad(false);
                } else {
                    createNotification("error", "Error in loading products!");
                }
            })
            .catch((e) => {
                setIsCatItemLoading(false);
                createNotification("error", "Error in loading products!");
            });
    };

    useEffect(() => {
        getCategories();
        getByCategory(1, subcategoryId);
        window.addEventListener("scroll", handleScroll, { passive: true });

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        overlayRef.current.addEventListener("click", (e) => {
            e.stopPropagation();
            handleSideNavClose();
        });

        openNavRef.current.addEventListener("click", (e) => {
            e.preventDefault();
            handleSideNavOpen();
        });
        closeBtnRef.current.addEventListener("click", (e) => {
            e.preventDefault();
            handleSideNavClose();
        });
    });

    const handleSideNavOpen = () => {
        sideNavRef.current.style.transform = "translateX(0)";
        overlayRef.current.classList.add("sidebar-overlay");
    };

    const handleSideNavClose = () => {
        sideNavRef.current.style.transform = "translateX(-100%)";
        overlayRef.current.classList.remove("sidebar-overlay");
    };

    const getCategories = async () => {
        setIsCatLoading(true);
        await fetch(baseUrl + "all-categories")
            .then((res) => res.json())
            .then((res) => {
                setIsCatLoading(false);
                if (res.success) {
                    setCategories(res.data);
                } else {
                    createNotification("error", res.message);
                }
            })
            .catch((e) => {
                setIsCatLoading(false);
                createNotification("error", "Error in loading categories!");
            });
    };

    useEffect(() => {
        console.log("Fetching data for subcategory:", subcategoryId);
    }, [subcategoryId]);
    console.log(products);
    console.log(activeCategory);

    return (
        <div className="mt-2 container">
            {/* <Helmet>
                <title>{`Categories - Thrift Store Nepal`}</title>
                <meta
                    name="description"
                    content="Categories - Thrift Store Nepal -  Search for your best matching thrift item according to the category. Buy and sell preowned clothes and other accessories on Nepal's first digital thrift shop - Thrift Store Nepal (Thrift Shop Nepal)"
                />
                <meta property="og:title" content="Categories - Thrift Store Nepal" />
                <meta
                    property="og:description"
                    content="Categories - Thrift Store Nepal -  Buy and sell preowned clothes and other accessories  on Nepal's first digital thrift shop - THrift Store Nepal (Thrift Shop Nepal)"
                />
                <meta name="og:image" content="/assets/images/og-2.png" />
            </Helmet> */}
            <div className="d-flex flex-column mt-4">
                <h3>Search by Categories</h3>
                {/* <span className='cat-trail text-primary cursor-pointer'>Didn't find what you are searching? <span>Search Here</span></span> */}
            </div>
            {pageOffset < 55 ? (
                <button
                    ref={openNavRef}
                    name="explore-cat-btn"
                    className={`btn btn-primary btn-sm d-block d-lg-none mt-3`}
                >
                    Explore Categories
                </button>
            ) : (
                <button
                    ref={openNavRef}
                    name="explore-cat-btn"
                    style={{ position: "fixed", bottom: 90, right: 10, zIndex: 3 }}
                    className={`btn btn-primary btn-sm d-block d-lg-none`}
                >
                    Explore Categories
                </button>
            )}

            <div className="col-12 d-flex mt-4 align-items-start">
                <div
                    className="col-4 col-xl-3 pe-1 d-none d-lg-block"
                    style={{ position: "sticky", top: 80 }}
                >
                    <div className=" w-100 me-1  p-2">
                        {isCatLoading ? (
                            Array(5)
                                .fill(0)
                                .map((_, i) => (
                                    <div
                                        key={i}
                                        className="shine mb-1"
                                        style={{ height: 40, width: "100%" }}
                                    ></div>
                                ))
                        ) : (
                            <RenderCollapsible
                                categories={categories}
                                activeCategory={activeCategory}
                                setActiveCategory={(cat) => {
                                    setActiveCategory(cat);
                                    console.log("First Cat", cat);
                                    if (cat.id !== activeCategory.id) {
                                        window.scrollTo(0, 0);
                                        setProducts([]);
                                        setIsFirstLoad(true);
                                        getByCategory(1, cat.id);
                                        // console.log("Second Cat", cat.id);
                                    }
                                }}
                                subcategoryId={subcategoryId}
                            />
                        )}
                    </div>
                </div>
                <div className="col-12 col-lg-8 col-xl-9">
                    <div className="bg-white w-100 h-100">
                        <div className="d-flex flex-wrap mb-5">
                            {isCatItemLoading && isFirstLoad ? (
                                <>
                                    {Array(7)
                                        .fill()
                                        .map((item, index) => {
                                            return (
                                                <ShimmerCard
                                                    key={index}
                                                    clsName="col-6 col-md-4"
                                                    index={index}
                                                />
                                            );
                                        })}
                                </>
                            ) : products.length > 0 ? (
                                <>
                                    {products.map((product, index) => {
                                        return (
                                            <ItemCard
                                                item={product}
                                                key={index}
                                                clsName="col-6 col-md-4 "
                                                index={index}
                                            />
                                        );
                                    })}
                                    {isCatItemLoading &&
                                        Array(10)
                                            .fill()
                                            .map((_, index) => {
                                                return (
                                                    <ShimmerCard
                                                        key={index}
                                                        clsName="col-6 col-md-4"
                                                        index={index}
                                                    />
                                                );
                                            })}
                                    {/* {forPagination.next_page_url &&
                                        <div onClick={() => { setCurrentPage(currentPage + 1); getByCategory(currentPage + 1, activeCategory.id); }} style={{ minHeight: 250 }} className="col-6 col-md-4 col-lg-4 cursor-pointer p-2">
                                            <div style={{ borderRadius: "10px" }} className="col-12 bg-white shadow d-flex align-items-center justify-content-center p-2 h-100">
                                                {!isCatItemLoading ? <p className="fs-4 fw-bold">Load More</p> :
                                                    <div className="spinner-border text-primary" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    } */}
                                    <LoadMore
                                        forPagination={forPagination}
                                        isLoading={isCatItemLoading}
                                        onClick={() => {
                                            setCurrentPage(currentPage + 1);
                                            getByCategory(currentPage + 1, activeCategory.id);
                                        }}
                                    />
                                </>
                            ) : (
                                <>
                                    <NoItems
                                        subText={`No products found for category '${activeCategory.category_name}'. You can still search for other categories.`}
                                    />
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <>
                <div ref={sideNavRef} id="mySidenav" className="sidenav">
                    <div className="d-flex flex-wrap justify-content-between px-3">
                        <p className="fw-bold my-auto">Explore Categories</p>
                        <div className="my-auto cursor-pointer" ref={closeBtnRef}>
                            &times;
                        </div>
                    </div>
                    <div className="bg-white w-100 p-3">
                        <RenderCollapsible
                            categories={categories}
                            activeCategory={activeCategory}
                            setActiveCategory={(cat) => {
                                setActiveCategory(cat);
                                if (cat.id !== activeCategory.id) {
                                    window.scrollTo(0, 0);
                                    setProducts([]);
                                    setIsFirstLoad(true);
                                    getByCategory(1, cat.id);
                                }
                            }}
                        />
                    </div>
                </div>
            </>
            <div ref={overlayRef}></div>
        </div>
    );
};

export default SingleCategory;
